import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { GOOGLE_ANALYTICS_ID } from '../../../platforms/web/src/config/clientEnvConfig';
import { useAppConfig } from './useAppConfig';

const useAnalytics = () => {
  const { isGoogleAnalytics } = useAppConfig();

  useEffect(() => {
    if (isGoogleAnalytics) {
      ReactGA.initialize(GOOGLE_ANALYTICS_ID);
    }
  }, [isGoogleAnalytics]);
};

export default useAnalytics;
